module.exports = __webpack_public_path__ + "media/images/contacts/icon-contacts-01-3628723c1c2247735a2e6fe526286a0e.svg";